import React from 'react';
import { useSelector } from 'react-redux';

import ConfirmationPageBenefitsIntake from './ConfirmationPageBenefitsIntake';
import ConfirmationPageQuickSubmit from './ConfirmationPageQuickSubmit';

export const ConfirmationPage = props => {
  const { data: formData } = useSelector(state => state.form);

  // The entire confirmation page is different based on Benefits Intake API or QuickSubmit
  return formData?.['view:form0803BenefitsIntakeSubmission'] ? (
    <ConfirmationPageBenefitsIntake {...props} />
  ) : (
    <ConfirmationPageQuickSubmit {...props} />
  );
};

export default ConfirmationPage;
